
import PropTypes from 'prop-types';
import { Tooltip as ReactTooltip } from 'react-tooltip';

// default css ./node_modules/react-tooltip/dist/react-tooltip.css
// Overwrite default css in _tooltip.scss
//
/**
 * Example https://react-tooltip.com/docs/options
 *
 * import { Tooltip } from 'react-tooltip';
 *
 * <a
 *   data-tooltip-id="my-tooltip"
 *   data-tooltip-content="Hello world!"
 *   data-tooltip-html=(<></>)
 *   data-tooltip-place="bottom"
 * >
 *   ◕‿‿◕
 * </a>
 * <Tooltip id="my-tooltip" />
 *
 * @param { id: 'tooltip', debug: undefined | true } param0
 * @returns
 */
const Tooltip = ({ id, debug }) => {
    return (
        <ReactTooltip
            id={id ?? "tooltip"}
            place="bottom"
            offset='4'
            isOpen={debug}
        />
    )
}

Tooltip.propTypes = {
	id: PropTypes.string,
	debug: PropTypes.bool,
}

export default Tooltip
